/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ScheduleFilterItemsDto } from '../../models/schedule-filter-items-dto';

export interface AllScheduleControllerGetFilterItems$Params {

/**
 * 센터 ID 단일 검색
 */
  centerId?: string;

/**
 * 센터 ID 다중 검색
 */
  centerIds?: Array<string>;

/**
 * 아동 ID 단일 검색
 */
  childId?: string;
}

export function allScheduleControllerGetFilterItems(http: HttpClient, rootUrl: string, params?: AllScheduleControllerGetFilterItems$Params, context?: HttpContext): Observable<StrictHttpResponse<ScheduleFilterItemsDto>> {
  const rb = new RequestBuilder(rootUrl, allScheduleControllerGetFilterItems.PATH, 'get');
  if (params) {
    rb.query('centerId', params.centerId, {});
    rb.query('centerIds', params.centerIds, {});
    rb.query('childId', params.childId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ScheduleFilterItemsDto>;
    })
  );
}

allScheduleControllerGetFilterItems.PATH = '/api/all-schedule/filter';
